export default "__VITE_PUBLIC_ASSET__8f320adf__"